<div class="form-group">
  @if (showLabel && (question?.question_copy || question?.email_version)) {
    <label>
      {{showLabelQuestionCopy ? question?.question_copy : question?.email_version}}
    </label>
  }
  <input
    type="number"
    [name]="uniqueControlName"
    [id]='uniqueId'
    [placeholder]="question?.question_prompt"
    class="form-control"
    [disabled]="readOnly"
    [(ngModel)]="value"
    (ngModelChange)="saveValue()"

    >
    <!--
    mask="percent"
    suffix="%"-->
  </div>